module.exports = __webpack_public_path__ + "static/media/fee.16951ebb.svg";